module.exports = __webpack_public_path__ + "img/3.4da6d8cf.png";